const rootArea = "/users";

export const usersGlob = (baseArea: string) => ({
	self: `${baseArea}${rootArea}`,
	read: `${baseArea}${rootArea}/read`
});